import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetSubscriptionPlansDto } from '@/types/dtos/transactions/response/get-subscription-plans.dto.ts';

/** Query key prefix; `invalidateQueries({ queryKey: [GET_SUBSCRIPTION_PLANS] })` matches all `[GET_SUBSCRIPTION_PLANS, entityType]` queries (default prefix match). */
export const GET_SUBSCRIPTION_PLANS = 'get-subscription-plans';

export const SUBSCRIPTABLE_ENTITIES = ['Organization', 'Event'] as const;
export type SubscriptionPlanEntity = (typeof SUBSCRIPTABLE_ENTITIES)[number];

export const useSubscriptionPlansQuery = ({
  entityType,
  enabled = true,
}: {
  entityType: SubscriptionPlanEntity;
  enabled?: boolean;
}) => {
  const { getToken } = useAuth();
  return useQuery({
    enabled,
    queryKey: [GET_SUBSCRIPTION_PLANS, entityType],
    queryFn: async () => {
      const token = await getToken();
      return getSubscriptionPlans({ entityType, token: token ?? '' });
    },
  });
};

const getSubscriptionPlans = async ({
  entityType,
  token,
}: {
  entityType: SubscriptionPlanEntity;
  token: string;
}): Promise<GetSubscriptionPlansDto> => {
  const url = `${import.meta.env.VITE_API_URL}/transactions/subscription-plans?entityType=${entityType}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
